const DateFormat = require('@/lib/Dates/DateFormat');
const Device = require('@/lib/Devices/Device');
const moment = require('moment');
const TradingSessionEvent = require('@/lib/TradingSessions/TradingSessionEvent');
const TradingSessionFinancialSummary = require('@/lib/TradingSessions/TradingSessionFinancialSummary');
const { toFloat, toInt } = require('@/functions/transform');

/**
 * @constructor
 */
const TradingSession = function () {
    /**
     * @type {Date|null}
     */
    this.endedAt = null;

    /**
     * @type {Device|null}
     */
    this.device = null;

    /**
     * @type {number}
     */
    this.deviceID = null;

    /**
     * @type {number}
     */
    this.ID = null;

    /**
     * @type {Data}
     */
    this.startedAt = null;

    /**
     * @type {number}
     */
    this.tradingSessionStatusID = null;

    /**
     * @type {TradingSessionEvent[]}
     */
    this.tradingSessionEvents = [];

    /**
     * @type {TradingSessionFinancialSummary[]}
     */
    this.tradingSessionFinancialSummaries = [];
};

TradingSession.prototype = {
    getHydrationMap() {
        return {
            device: {
                model: Device,
            },
            deviceID: toInt,
            endedAt: {
                transform(value) {
                    // Convert from UTC date.
                    // FIXME: PRO-916 API should output in ISO8601 so we don't need to be concerned with this.
                    return value === null ? null : moment.utc(value).toDate();
                },
            },
            ID: {
                field: ['ID', 'tradingSessionID'],
                transform: toInt,
            },
            startedAt: {
                transform(value) {
                    // Convert from UTC date
                    // FIXME: PRO-916 API should output in ISO8601 so we don't need to be concerned with this.
                    return value === null ? null : moment.utc(value).toDate();
                },
            },
            tradingSessionEvents: {
                modelCollection: TradingSessionEvent,
            },
            tradingSessionFinancialSummaries: {
                modelCollection: TradingSessionFinancialSummary,
            },
            tradingSessionStatusID: toInt,
            type: toInt,
            cashBanked: toFloat,
        };
    },

    get formattedDate() {
        let str = moment(this.startedAt).format(DateFormat.DATE_WITH_TIME);

        if (this.endedAt) {
            str += ' - ' + moment(this.endedAt).format(DateFormat.DATE_WITH_TIME);
        } else {
            // This could append " - Now" but then it would require LangService to translate "Now".
            // For the time being just " - " should suffice.
            str += ' - ';
        }

        return str;
    },
};

module.exports = TradingSession;
